module.exports = __webpack_public_path__ + "static/img/pic_tupian_vip@2x.267d4220.png";